<template>
  <div class="main_body contact_page">
    <section id="hero_section">
      <div class="container">
        <navbar></navbar>
        <div class="main_logo">
          <img src="@/assets/images/Logo-011.png" alt="Logo-011.png">
        </div>
        <section class="contact_section">
          <div class="heading_section">
            <h3>Email Verification</h3>
            <div v-if="this.$store.getters.apiStatus === 'loading'" class="loader">
              <h4>
                <div class="d-flex">
                  Verifying email
                  <Loader />
                </div>
              </h4>
            </div>
            <div v-else>
              <h4>{{message}}</h4>
            </div>
          </div>

        </section>

      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'EmailVerification',
  data () {
    return {
      message: ''
    }
  },
  created () {
    var data = {
      id: this.$route.params.id,
      hash: this.$route.params.hash,
      queryParams: 'expires=' + this.$route.query.expires + '&signature=' + this.$route.query.signature
    }
    this.$store
      .dispatch('verifyEmail', data)
      .then((resp) => {
        this.message = resp.data.message
        this.$toast.success(resp.data.message)
        this.$router.push('/')
      })
      .catch((err) => {
        this.message = err.response.data.message
        console.log(err)
      })
  }
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/EmailVerification.vue